import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';
import { getAppDetails } from '../util/_api';
import * as utils from '../../../utils';
import classes from '../UserAccessReview.module.scss';

const ServiceAccountAppDetails = ({ account }) => {
	const [appDetails, setAppDetails] = useState(null);

	useEffect(() => {
		if (account.displayApps) {
			getAppDetails(account.esoFiId)
				.then(response => setAppDetails(response))
				.catch(() => setAppDetails([]));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [account.displayApps]);

	const expandRole = (e, id) => {
		let newApplications = [...appDetails];
		newApplications.forEach(app => {
			if (app.id === id) {
				app.showFull = app.showFull ? !app.showFull : true;
			}
		});
		setAppDetails(newApplications);
	};

	return (
		account.displayApps &&
		appDetails &&
		appDetails.map(app => {
			return (
				<div
					className={utils.concatenateClassNames(
						['profile__container--application--service-account'],
						classes
					)}
					key={nanoid()}
				>
					<div
						className={utils.concatenateClassNames(
							['profile__item', 'profile__application--title'],
							classes
						)}
					>
						{app.name}
					</div>
					<div
						className={utils.concatenateClassNames(
							['profile__item', 'profile__application--username'],
							classes
						)}
					>
						{app.username}
					</div>
					<div
						className={utils.concatenateClassNames(
							['profile__item', 'profile__application--role'],
							classes
						)}
					>
						{app.role && app.role.length > 100 ? (
							app.showFull ? (
								<span>
									{app.role}{' '}
									<span
										onClick={e => expandRole(e, app.id)}
										className={utils.concatenateClassNames(
											['link'],
											classes
										)}
									>
										(see less)
									</span>
								</span>
							) : (
								<span>
									{app.role.substring(0, 86) + '... '}{' '}
									<span
										onClick={e => expandRole(e, app.id)}
										className={utils.concatenateClassNames(
											['link'],
											classes
										)}
									>
										(see more)
									</span>
								</span>
							)
						) : (
							app.role
						)}
					</div>
				</div>
			);
		})
	);
};
export default ServiceAccountAppDetails;
